import React from "react";
import { decodeHTML } from "../helpers.mjs";

const BookTitle = ({ source }) => {
    var languageArray = [];
    
    if (source.language != null) {
        if(source.language?.length >= 2) {
            languageArray = source.language?.map(l => l.title);
        } else {
            languageArray = source.language?.filter(l => (l.value != "E" && l.value != "eng")).map(l => l.title);
        }
    }

    return <h1 className="pageTitle">
        {source.isbookpack == 1 && <><span className="subtitle">{source.subtitle}</span> {source.title}</>}
        {source.isbookpack != 1 && <>{decodeHTML(`${source.title}${source.subtitle ? `: ${source.subtitle}` : ''}`)}</>}
        {languageArray?.length > 0 && languageArray[0] && <span>&nbsp;({languageArray.join("/")})</span>}
    </h1>
}

export default BookTitle;